import { useEffect, useRef } from 'react';

const useUrlChange = (callback: () => void) => {
  const oldHref = useRef(window.location.href);
  const observer = useRef<any>(null);

  useEffect(() => {
    const onUrlChange = () => {
      if (oldHref.current !== window.location.href) {
        oldHref.current = window.location.href;
        callback();
      }
    };
    observer.current = new MutationObserver(onUrlChange);
    observer.current.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.current.disconnect();
    };
  }, [callback]);

};

export default useUrlChange;
